const CreatePayment = () => import('@/modules/orders/views/CreatePayment')
const NFSeShow = () => import('@/modules/orders/views/NFSeShow')

export default [
  {
    path: '/orders/:id/payment',
    name: 'orders.payment.create',
    component: CreatePayment
  },
  {
    path: '/orders/:id/nfse',
    name: 'orders.nfse.show',
    component: NFSeShow,
    meta: { requiresAuthentication: true }
  }
]
